import {CMS_BML, CMS_MAPPING, CmsLangBmls, CmsBrand} from '../interface';

const CMS = {
  BUICK: 'buick',
  CADILLAC: 'cadillac',
  CHEVROLET: 'chevrolet',
  GM: 'gm',
  GMC: 'gmc'
} as const;

const LANG = {
  EN: 'en',
  FR: 'fr',
  ES: 'es'
} as const;

export class AppBmls {
  private map: CMS_MAPPING;

  constructor(private obj: CmsLangBmls, public APP?: string) {
    this.map = this.generateCmsMap(obj);
  }

  getId = (brand: string, lang: string): number => {
    const ids = this.map.get(lang);
    if (!ids) throw new Error('CMS MAP ERROR: lang');
    const id = ids.get(brand);
    if (!id) throw new Error('CMS MAP ERROR: market');
    return id;
  };

  private generateCmsMap = (cmsObj: CmsLangBmls): CMS_MAPPING => {
    const cmsMap: CMS_MAPPING = new Map<string, CMS_BML>();
    for (const language in cmsObj) {
      if (!Object.values<string>(LANG).includes(language))
        console.warn(`WARNING: Language "${language}" is not registered`);
      cmsMap.set(language, this.generateMap(cmsObj[language]));
    }
    return cmsMap;
  };

  private generateMap = ({
    chevrolet,
    cadillac,
    buick,
    gm,
    gmc
  }: CmsBrand): CMS_BML =>
    new Map()
      .set(CMS.BUICK, buick)
      .set(CMS.CHEVROLET, chevrolet)
      .set(CMS.CADILLAC, cadillac)
      .set(CMS.GM, gm)
      .set(CMS.GMC, gmc);
}
